import { useEffect, useState } from 'react'

/*
 * Login and invitation links carry the token in the URL fragment (#t=…), which browsers never
 * send to servers or put in Referer headers. It is read, then removed from the address bar;
 * only the POST of the page's button consumes it (ADR 0001, D3).
 */

function readFragmentToken(): string | null {
  return /(?:^#|&)t=([A-Za-z0-9_-]{20,200})/.exec(window.location.hash)?.[1] ?? null
}

/** The token of the current page, also when a link is opened in a tab already on this page. */
export function useFragmentToken(): string | null {
  const [token, setToken] = useState(readFragmentToken)
  useEffect(() => {
    const clear = () => {
      if (window.location.hash)
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
    }
    clear()
    const onChange = () => {
      const next = readFragmentToken()
      if (next) {
        setToken(next)
        clear()
      }
    }
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])
  return token
}
